import { css } from 'lit'
import HHQuizElement from '../element.js'
import { html, unsafeStatic } from 'lit/static-html.js'
import { updateRemoteStorage } from '../store/utility-remote-storage.js'

/**
 * Summary view
 * @extends
 */

class HHQuizViewSummary extends HHQuizElement {
  connectedCallback() {
    super.connectedCallback()
    updateRemoteStorage()
  }
  /**
   * Renders the current route
   * @returns {TemplateResult}
   */
  render() {
    return html`
      <div class="hh-quiz-view-summary">
        <div class="hh-quiz-view-summary__header">
          <h1 class="h6 focus-first focus-none" tabindex="0">
            ${this.hydrateText(this.store.quiz.texts.results.title)}
          </h1>
          <h1 class="h2" tabindex="0">
            ${this.hydrateText(this.store.quiz.texts.results.title)}
          </h1>
          <p class="body" tabindex="0">
            ${unsafeStatic(
              this.hydrateText(this.store.quiz.texts.results.message)
            )}
          </p>
        </div>
        <div class="hh-quiz-view-summary__body">
          <div
            class="hh-quiz-view-summary__body__col hh-quiz-view-summary__body__left"
          >
            <div class="hh-quiz-view-summary__section-title h4">
              ${HH_QUIZ.t.cart.your_cecred_ritual}
            </div>
            <div class="hh-quiz-view-summary__section">
              <hh-quiz-selected-products></hh-quiz-selected-products>
            </div>
          </div>
          <div
            class="hh-quiz-view-summary__body__col hh-quiz-view-summary__body__right"
          >
            <div class="hh-quiz-view-summary__section-title h4">
              ${HH_QUIZ.t.cart.order_summary}
            </div>
            <div class="hh-quiz-view-summary__section">
              <hh-quiz-selected-products-order></hh-quiz-selected-products-order>
            </div>
          </div>
        </div>
      </div>
      <hh-quiz-georgias-widget></hh-quiz-georgias-widget>
    `
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-view-summary {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-height: calc(100vh - 60px);
      }
      .hh-quiz-view-summary__header {
        padding: 0px 20px 60px;
        text-align: center;
        max-width: min(max(45vw, 657px), calc(100vw - 40px));
        width: 100%;
        margin: 14px auto 0;
        color: var(--hh-color-aged-black);
      }

      .hh-quiz-view-summary__header .h6,
      .hh-quiz-view-summary__header .h2 {
        margin-bottom: 20px;
      }

      .hh-quiz-view-summary__header .h2 {
        display: none;
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .hh-quiz-view-summary__header {
          text-align: left;
          margin-top: 6px;
        }

        .hh-quiz-view-summary__header .h6 {
          display: none;
        }

        .hh-quiz-view-summary__header .h2 {
          display: block;
          margin-bottom: 18px;
        }
      }

      .hh-quiz-view-summary__body {
        display: flex;
        flex-grow: 1;
      }

      @media screen and (max-width: ${HHQuizElement.mq.md}px) {
        .hh-quiz-view-summary__body {
          display: block;
        }
      }

      .hh-quiz-view-summary__body__col {
        border-top: 1px solid var(--hh-color-grey-mineral);
      }

      .hh-quiz-view-summary__body__left {
        flex-grow: 1;
        border-right: 1px solid var(--hh-color-grey-mineral);
      }

      .hh-quiz-view-summary__body__right {
        width: max(520px, 36vw);
      }

      @media screen and (max-width: ${HHQuizElement.mq.md}px) {
        .hh-quiz-view-summary__body__right {
          min-width: 100%;
          max-width: 100vw;
        }
      }

      .hh-quiz-view-summary__section-title {
        margin-top: -1px;
        border-bottom: 1px solid var(--hh-color-grey-mineral);
        height: 56px;
        display: flex;
        align-items: center;
        padding: 0 60px;
        color: var(--hh-color-aged-black);
      }

      @media screen and (max-width: ${HHQuizElement.mq.xs}px) {
        .hh-quiz-view-summary__section-title {
          padding: 0 20px;
        }
      }

      .hh-quiz-view-summary__section {
        color: var(--hh-color-aged-black);
      }
    `,
  ]
}

customElements.define('hh-quiz-view-summary', HHQuizViewSummary)
